'use client';

import { NotificationBell } from '@/components/notifications/notification-bell';

export interface SellerTopBarProps {
  storeName: string;
}

export function SellerTopBar({ storeName }: SellerTopBarProps) {
  return (
    <header className="flex h-14 items-center justify-between border-b border-forest/10 bg-white px-6">
      <div className="text-sm font-semibold text-forest">{storeName}</div>
      <div className="flex items-center gap-4">
        <NotificationBell seeAllHref="/seller/inbox" />
      </div>
    </header>
  );
}
